import React from 'react'
import { Grid, Tooltip, Theme, Link as MuiLink } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import messages from '../../messages'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) => {
  return {
    label: {
      fontWeight: theme.typography.fontWeightBold,
      fontSize: theme.typography.pxToRem(14),
    },
    vectorLabel: {
      color: '#3c3c4bdb',
      fontSize: theme.typography.pxToRem(13),
    },
    vectorLabel2: {
      paddingBottom: theme.spacing(4),
    },
    InfoPopup: {
      width: theme.spacing(167),
      maxWidth: 'none',
      backgroundColor: theme.palette.common.white,
      position: 'relative',
      border: `1px solid ${theme.palette.common.white}`,
      boxShadow: '1px 1px 20px 1px lightgrey',
      padding: theme.spacing(5),
      fontSize: theme.typography.pxToRem(12),
      color: '#1b1b25',
      borderRadius: '2%',
      marginTop: theme.spacing(1),
    },
    arrow: {
      color: theme.palette.common.white,
    },
    icon: {
      fontSize: theme.typography.pxToRem(16),
      verticalAlign: 'middle',
    },
  }
})

const PerformanceGuaranteePopUp = () => {
  const classes = useStyles()
  const email = 'oligotechserv@merckgroup.com'

  return (
    <>
      <Grid>
        <div className={classes.label}>
          <Tooltip
            title={
              <div className={classes.vectorLabel}>
                <div className={classes.vectorLabel2}>
                  <FormattedMessage
                    {...messages.SEMICONF_PERFORMANCE_GUARANTEE_POPUP_CONTENT_crisprgrna}
                  />
                </div>
                <div>
                  <FormattedMessage
                    {...messages.SEMICONF_PERFORMANCE_GUARANTEE_POPUP_SECONDHALF_crisprgrna}
                  />
                  &nbsp;
                  <a href={`mailto:${email}`}>{email}</a>
                  &nbsp;
                  <FormattedMessage
                    {...messages.SEMICONF_PERFORMANCE_GUARANTEE_POPUP_CONTENT_AFTEREMAIL_crisprgrna}
                  />
                </div>
              </div>
            }
            interactive
            placement="right"
            classes={{
              tooltip: classes.InfoPopup,
              arrow: classes.arrow,
            }}
            arrow
          >
            <MuiLink color="primary">
              <FormattedMessage
                {...messages.SEMICONF_PERFORMANCE_GUARANTEE_POPUP_TEXT_crisprgrna}
              />
            </MuiLink>
          </Tooltip>
        </div>
      </Grid>
    </>
  )
}
export default PerformanceGuaranteePopUp
